import React, { useState, FC } from 'react';
import { SpheraButton, SpheraModal, SpheraDateTimePicker } from '@sphera-cloud/component-ui-reactjs';
import { FileDetailsModalProps } from './interfaces';
import { formatBytes } from 'src/utilities/fileSize';
import './styles.scss';
import { useUserSettings } from 'src/hooks/useUserSettings';

const BASIC_WIDTH = 700;
const BASIC_HEIGHT = 521;

const FileDetailsModal: FC<FileDetailsModalProps> = ({
  details,
  closeModal,
  downloadFile,
  deleteFile,
  onAction,
}) => {
  const [height, setHeight] = useState<number | string>(BASIC_HEIGHT);
  const [width, setWidth] = useState<number | string>(BASIC_WIDTH);
  const [expirationModal, setExpirationModal] = useState<boolean>(false);
  const [expireDate, setExpireDate] = useState<string>(details.expirationDate ?? '');
  const [maximize, setMaximize] = useState(true);
  const [minimize, setMinimize] = useState(false);
  const { fileId, name, mimeType, fileSize, status, creationDatetime, lastChangeDatetime, expirationDate } =
    details;
  const { getFormattedDateTime, getFormattedExpirationDateTime } = useUserSettings();

  return (
    <SpheraModal
      title="File Details"
      onClose={() => {
        closeModal(false);
      }}
      onCancel={() => {
        closeModal(false);
      }}
      onAction={() => onAction(expirationModal, details.fileId, expireDate)}
      className="ds-file-details"
      actions
      actionText={expirationModal ? 'Update' : 'Close'}
      height={height}
      width={width}
      useMaximizeButton={maximize}
      useMinimizeButton={minimize}
      onMaximize={() => {
        setHeight(1000);
        setWidth(1660);
        setMaximize(false);
        setMinimize(true);
      }}
      onMinimize={() => {
        setHeight(BASIC_HEIGHT);
        setWidth(BASIC_WIDTH);
        setMaximize(true);
        setMinimize(false);
      }}
    >
      <div className="file-details">
        {!expirationModal ? (
          <>
            <div className="file-details--list-item">
              <p className="file-details--item-title">Name:</p>
              <p className="file-details--item-value">{name}</p>
            </div>
            <div className="file-details--list-item">
              <p className="file-details--item-title">Id:</p>
              <p className="file-details--item-value">{fileId}</p>
            </div>
            <div className="file-details--list-item">
              <p className="file-details--item-title">Type:</p>
              <p className="file-details--item-value">{mimeType}</p>
            </div>
            <div className="file-details--list-item">
              <p className="file-details--item-title">Status:</p>
              <p className="file-details--item-value">{status}</p>
            </div>
            <div className="file-details--list-item">
              <p className="file-details--item-title">Creation:</p>
              <p className="file-details--item-value">
                {getFormattedDateTime(creationDatetime)}
              </p>
            </div>
            <div className="file-details--list-item">
              <p className="file-details--item-title">Expiration date:</p>
              <p className="file-details--item-value">
                { getFormattedExpirationDateTime(expirationDate) }
              </p>
            </div>
            <div className="file-details--list-item">
              <p className="file-details--item-title">Last Change:</p>
              <p className="file-details--item-value">
                {getFormattedDateTime(lastChangeDatetime)}
              </p>
            </div>
            <div className="file-details--list-item">
              <p className="file-details--item-title">File Size:</p>
              <p className="file-details--item-value">
                {formatBytes(fileSize)} ({fileSize.toLocaleString()} Bytes)
              </p>
            </div>
            <div className="file-details--action-buttons">
              {details.status === 'Succeeded' && (
                <SpheraButton text="Download" onClick={() => downloadFile(details)} />
              )}
              <SpheraButton text="Set expiration date" onClick={() => setExpirationModal(true)} />
              <SpheraButton text="Delete" onClick={() => deleteFile(details)} />
            </div>
          </>
        ) : (
          <>
            <div className="file-details--expire-label">Expiration date</div>
            <SpheraDateTimePicker min={new Date()} value={expireDate || null} onChange={(e: any) => setExpireDate(e?.value || '')} />
          </>
        )}
      </div>
    </SpheraModal>
  );
};

export default FileDetailsModal;
